// Mirrors server/utils/schoolTime.js — "today"/"now" as observed in the
// school's timezone, not the browser's. Without this, a student's device
// set to a different timezone would see UI hints (which button is
// active, which day's record is "today") that disagree with what the
// backend actually enforces, which uses the school's timezone.
const SCHOOL_TIMEZONE = process.env.REACT_APP_SCHOOL_TIMEZONE || 'Asia/Kolkata';

const partsNow = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: SCHOOL_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const get = (type) => parts.find((p) => p.type === type).value;
  return { year: get('year'), month: get('month'), day: get('day'), hour: get('hour'), minute: get('minute'), second: get('second') };
};

export const schoolToday = () => {
  const p = partsNow();
  return `${p.year}-${p.month}-${p.day}`;
};

export const schoolNowTime = () => {
  const p = partsNow();
  return `${p.hour}:${p.minute}:${p.second}`;
};
